import { render, staticRenderFns } from "./CaseMedicationEffectChain.vue?vue&type=template&id=4a8aba4c&scoped=true&"
import script from "./CaseMedicationEffectChain.vue?vue&type=script&lang=js&"
export * from "./CaseMedicationEffectChain.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedicationEffectChain.vue?vue&type=style&index=0&id=4a8aba4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8aba4c",
  null
  
)

export default component.exports